import { render, staticRenderFns } from "./JobAssignment.vue?vue&type=template&id=56115d3c&scoped=true"
import script from "./JobAssignment.vue?vue&type=script&lang=js"
export * from "./JobAssignment.vue?vue&type=script&lang=js"
import style0 from "./JobAssignment.vue?vue&type=style&index=0&id=56115d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56115d3c",
  null
  
)

export default component.exports